'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _containers = require('../../containers');
var _components = require('../../components');
var _constants = require('../../constants');
var _LineFilterContainer = require('../../containers/LineFilterContainer/LineFilterContainer.scss');var styles = _interopRequireWildcard(_LineFilterContainer);function _interopRequireWildcard(obj) {if (obj && obj.__esModule) {return obj;} else {var newObj = {};if (obj != null) {for (var key in obj) {if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];}}newObj.default = obj;return newObj;}}function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var LineFiltersHomes = function LineFiltersHomes(props) {var

  types =






  props.types,rooms = props.rooms,advancedFiltersQuantity = props.advancedFiltersQuantity,favoritesListIsActive = props.favoritesListIsActive,translate = props.translate,propertyTypes = props.propertyTypes,isCommercial = props.isCommercial;

  var opTypesValues = _constants.optionTypesValues.
  filter(function (_ref) {var value = _ref.value;return !isCommercial || value !== _constants.optionTypes['rent-short'];}).
  map(function (_ref2) {var title = _ref2.title,value = _ref2.value;return {
      label: translate('search_box', 'searchContainer', title).toString(),
      selected: false,
      value: value };});


  return (
    _react2.default.createElement('div', { className: 'filters', style: { height: _constants.filtersHeight + 'px' } },

      !favoritesListIsActive &&
      _react2.default.createElement('div', { className: styles.filtersCover },
        _react2.default.createElement('div', { className: styles.filtersWrapper },
          _react2.default.createElement('div', { className: styles.locationInput }),
          _react2.default.createElement(_components.OMOptionTypeDropdown, {
            translate: translate('search_box', 'searchContainer'),
            value: props.optionType,
            handleChange: function handleChange(val) {return props.handleChange('optionType', val);},
            options: opTypesValues,
            className: 'lineFilterDropdown' }),

          _react2.default.createElement(_containers.PropertyTypesDropdownContainer, {
            locale: props.locale,
            propertyTypes: propertyTypes,
            propertyTypesValues: types,
            translate: translate,
            handleChange: function handleChange(val) {return props.handleChange('types', val);},
            className: 'lineFilters',
            width: 150,
            optionType: props.optionType }),

          _react2.default.createElement(_containers.RoomsDropdownContainer, {
            rooms: rooms,
            translate: translate('search_box'),
            handleChange: function handleChange(val) {return props.handleChange('rooms', val);},
            className: 'lineFilters',
            width: 110 }),

          _react2.default.createElement('div', { className: (0, _classnames2.default)(styles.homesPrice, styles.priceWrapper) },
            _react2.default.createElement(_components.MinMaxPrices, {
              inFilters: true,
              className: 'lineFiltersPrice',
              translate: translate('search_box', 'searchContainer'),
              minPrice: props.formatPriceParameters('minPrice'),
              maxPrice: props.formatPriceParameters('maxPrice') }),

            _react2.default.createElement('span', null, '\u20AA')),


          _react2.default.createElement('div', { className: styles.advancedFilters, onClick: props.handleOpenAdvancedFilters },
            translate('search_box', 'searchContainer', 'advanced_filters'), '\xA0',
            advancedFiltersQuantity > 0 && '(' + advancedFiltersQuantity + ')')),


        _react2.default.createElement('div', { className: styles.verticalDivider })),



      favoritesListIsActive &&
      _react2.default.createElement('div', {
          className: styles.listType,
          onClick: function onClick() {
            props.setFavoritesListState();
          } },

        _react2.default.createElement('div', { className: styles.backToSearchBtn }, translate('propertyDetails', 'details', 'backToSearch')))));




};

LineFiltersHomes.propTypes = {
  handleChange: _propTypes2.default.func,
  formatPriceParameters: _propTypes2.default.func,
  handleOpenAdvancedFilters: _propTypes2.default.func,
  saveSearchLocation: _propTypes2.default.func,
  setFavoritesListState: _propTypes2.default.func,
  translate: _propTypes2.default.func,
  propertyTypes: _propTypes2.default.array,
  locale: _propTypes2.default.string,
  favoritesListIsActive: _propTypes2.default.bool,
  isCommercial: _propTypes2.default.bool,
  optionType: _propTypes2.default.string,
  types: _propTypes2.default.array,
  rooms: _propTypes2.default.array,
  advancedFiltersQuantity: _propTypes2.default.number };exports.default =


LineFiltersHomes;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LineFilters/LineFiltersHomes.js
// module id = 2723
// module chunks = 0